import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import PauseIcon from '../../images/pause.svg';
import PlayIcon from '../../images/play.svg';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import useDocumentTitle from '../../shared/hooks/title-hook';
import { useLanguageAttribute } from '../../shared/hooks/useLanguageAttribute';
import { getNotLoggedInPageTitle } from '../../shared/util/pageTitles';
import Carousel from './Carousel';

function Layout({ children, page = null }) {
  const { t } = useTranslation();

  const { isLoading } = useHttpClient();
  const { pathname } = useLocation();
  const [isAnimationPaused, setIsPauseAnimation] = useState(false);
  const pageTitle = page ?? getNotLoggedInPageTitle(pathname, t);
  useDocumentTitle(`${pageTitle} - Champion Health`, t('page.description.notLoggedIn'));
  useLanguageAttribute();

  const toggleAnimation = () => {
    setIsPauseAnimation(!isAnimationPaused);
  };

  return (
    <>
      {/* 
        Skip link - uncomment when we remove UserWay
      <a href="#main_content" className="skip-link">
        {t('accessibility.skip.to.main')}
      </a> */}
      <button
        type="button"
        className="pause_button transparent-button"
        onClick={toggleAnimation}
        style={{
          backgroundImage: isAnimationPaused ? `url(${PlayIcon})` : `url(${PauseIcon})`,
        }}
      >
        <span className="sr-only">
          {isAnimationPaused ? t('carousel.play.animation') : t('carousel.pause.animation')}
        </span>
      </button>
      <main id="main_container" className="register">
        <div id="main_content">
          {page && (
            <div role="status" className="sr-only" aria-live="polite">
              {pageTitle}
            </div>
          )}
          {isLoading && <LoadingSpinner asOverlay />}
          <div id="left_container" aria-hidden="true">
            <div className="main_text">{t('R001')}</div>
            <div className="secondary_text">{t('carousel.singup.subtitle')}</div>
            <div className="carousel_container">
              <Carousel ariaHidden isAnimationPaused={isAnimationPaused} />
            </div>
            <div className="fade" />
          </div>
          {children}
        </div>
      </main>
    </>
  );
}
export default Layout;
